// is object empty
// obj = {} returns true
// obj = {a:1} returns false
const isEmpty = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object;
export default isEmpty;
